import React, { useState } from 'react';

import { ReactComponent as Users } from '../../../assets/icons/Users.svg';
import { ReactComponent as Facture } from '../../../assets/icons/Facture.svg';
import { ReactComponent as Factures } from '../../../assets/icons/Factures.svg';
import Button from '../../Buttons/Button/Button';

import classes from './SelectOption.module.scss';

const _texts = {
  collaborator: {
    iconOne: <Users />,
    iconSecond: <Users />,
    title: 'Agregar colaboradores',
    description: '¿Cuántos colaboradores quieres agregar?',
    titleOne: 'Un colaborador',
    descriptionOne: 'Diligencia manualmente la información de tu colaborador.',
    titleSecond: 'Varios colaboradores',
    descriptionSecond: 'Descarga nuestra plantilla para llenarla con los datos de los colaboradores y la vuelves a subir.'
  },
  client: {
    iconOne: <Users />,
    iconSecond: <Users />,
    title: 'Agregar clientes',
    description: '¿Cuántos clientes quieres agregar?',
    titleOne: 'Un cliente',
    descriptionOne: 'Diligencia manualmente la información de tu cliente.',
    titleSecond: 'Varios clientes',
    descriptionSecond: 'Descarga la plantilla, completa la información de tus clientes y vuelve a subirla.'
  },
  facture: {
    iconOne: <Facture />,
    iconSecond: <Factures />,
    title: 'Crear cuenta',
    description: '¿Cuántas cuentas de cobro quieres agregar?',
    titleOne: 'Una cuenta',
    descriptionOne: 'Diligencia manualmente la información de tu cuenta de cobro.',
    titleSecond: 'Varias cuentas',
    descriptionSecond: 'Descarga la plantilla, completa la información de tus cuentas de cobro y vuelve a subirla.'
  },
  supplier: {
    iconOne: <Facture />,
    iconSecond: <Factures />,
    title: 'Crear proveedor',
    description: '¿Cuántos proveedores quieres agregar?',
    titleOne: 'Un proveedor',
    descriptionOne: 'Diligencia manualmente la información de tu proveedor.',
    titleSecond: 'Varios proveedores',
    descriptionSecond: 'Descarga la plantilla, completa la información de tus proveedores y vuelve a subirla.'
  }
};

const SelectOption = ({ optionSelected, type = 'collaborator', disabled = false }) => {
  const texts = _texts[type];
  const [optionAdd, setOptionAdd] = useState(null);

  const optionHandler = option => {
    setOptionAdd(option);
  };

  return (
    <div className={classes.content}>
      <span className='bold-20'>{texts?.title}</span>
      <span className={`${classes.ask} semibold-18`}>{texts.description}</span>
      <div className={classes.cards}>
        <div className={classes['card-text']}>
          <div
            onClick={() => optionHandler('one')}
            className={`${optionAdd === 'one' ? classes.selected : classes['not-selected']} ${classes['card-one']} pointer`}>
            <div className={classes['icons']}>{texts.iconOne}</div>
            <span className='semibold-18'>{texts.titleOne}</span>
          </div>
          <span className={`${classes.color} medium-12`}>{texts.descriptionOne}</span>
        </div>
        <div className={classes['card-text']}>
          <div
            onClick={() => optionHandler('some')}
            className={`${optionAdd === 'some' ? classes.selected : classes['not-selected']} ${classes['card-two']} ${
              disabled ? 'default' : 'pointer'
            }`}>
            <div className={classes['icons']}>{texts.iconSecond}</div>
            <span className='semibold-18'>{texts.titleSecond}</span>
          </div>
          <span className={`${classes.color} medium-12`}>{texts.descriptionSecond}</span>
        </div>
      </div>
      <div className={classes.down}>
        <Button onClick={() => optionSelected(optionAdd)} enabled={!!optionAdd}>
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default SelectOption;
